module.exports = __webpack_public_path__ + "img/bed.c2a7d094.svg";